import styles from './SurfaceBar.module.css';

export function SurfaceBar({
	actions = null,
	tabs = [],
	activeTab = undefined,
	onTabChange = undefined,
	className = ''
}) {
	const hasTabs = tabs.length > 0;

	return (
		<div className={`${styles.surfaceBar} ${!hasTabs ? styles.surfaceBarNoTabs : ''} ${className}`}>
			<div className={styles.actionsSlot}>{actions}</div>
			{hasTabs && (
				<div className={styles.tabsHeader}>
					{tabs.map(tab => (
						<button
							key={tab.id}
							type="button"
							className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ''}`}
							onClick={() => onTabChange?.(tab.id)}
						>
							{tab.label}
						</button>
					))}
				</div>
			)}
		</div>
	);
}
